if ($('.side-pager')[0]) {
    const sections = $('.acf-components section');

    for (let i = 1; i <= sections.length; i++) {
        if (i === 1) {
            $('.side-pager').append(
                `<li class="side-pager__item side-pager__item-active side-pager__item-${i}"><i>${i}</i></li>`
            );
        } else {
            $('.side-pager').append(`<li class="side-pager__item side-pager__item-${i}"><i>${i}</i></li>`);
        }

        $(window).on('scroll', function() {
            if ($(this).scrollTop() >= $(`section:nth-of-type(${i})`).position().top - 300) {
                $(`.side-pager__item`).removeClass('side-pager__item-active');
                $(`.side-pager__item-${i}`).addClass('side-pager__item-active');
            }
        });
    }
}
